// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5156":"4e0ad40a9069e746","5805":"4e0ad40a9069e746","6732":"4e0ad40a9069e746","9609":"4e0ad40a9069e746"}[chunkId] + ".css";
};